import { AreaInfo } from 'ais-facade-api/api';
import { setSelectedArea, setShowAreaCard } from '../utils/marineInfrastructureReducer';
import { setSelectedTarget } from '../utils/selectedTargetsSlice';
import { useAppDispatch } from '../store/store';

export const useZoneSelectHandler = () => {
  const dispatch = useAppDispatch();

  return (area: AreaInfo) => {
    dispatch(setSelectedArea(area));
    dispatch(setShowAreaCard(true));
    dispatch(setSelectedTarget(null));
  };
};
